import { dashedToCamelCase } from 'src/js/modules/utils/convert-case';

const generateAdjustedEventTraits = (options) =>
  options.reduce((acc, optionName) => {
    const prefix = dashedToCamelCase(optionName);
    const traitName = `${prefix}Adjusted`;

    return {
      ...acc,
      [traitName]: true,
    };
  }, {});

export default generateAdjustedEventTraits;
